<template>
  <div class="leftMenu" v-show="isShow">
    <div
      class="menuItem"
      :class="{ menuChecked: activeIndex === index }"
      v-for="(item, index) in brandList"
      @click="onCheck(index)"
    >
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import {
  spliceString,
  elementIsVisibleInViewport,
  scrollIntoView,
} from "@/utils";

export default {
  props: {
    brandList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeIndex: "",
      scrollTop: 0,
      bannerHeight: 0,
    };
  },
  computed: {
    isShow() {
      return this.scrollTop > 0 && this.scrollTop >= this.bannerHeight;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.getVisible);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getVisible);
  },
  methods: {
    onCheck(index) {
      const id = "preferredBrandFloor_" + index;
      const dom = document.getElementById(id);
      scrollIntoView(dom, 100);
    },
    getBannerHeight() {
      const dom = document.getElementById("preferredBrand-banner");
      if (dom) {
        const rect = dom.getBoundingClientRect();
        if (rect.height > this.bannerHeight) {
          this.bannerHeight = rect.height;
        }
      }
    },
    // 获取哪些模块在视图里
    getVisible() {
      this.getBannerHeight();
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      const visibleIndex = this.visibleIndex();
      if (visibleIndex.length >= 1) {
        this.$nextTick(() => {
          this.activeIndex = visibleIndex[0];
        });
      }
    },
    // 返回视图内的相应序号
    visibleIndex() {
      let jumpArr = [];
      let allSides = [];

      const homeDynamicsDom = document.getElementById(
        "preferredBrand-dynamics"
      );

      if (homeDynamicsDom) {
        [...homeDynamicsDom.children].forEach((item) => {
          const targetDom = item;
          if (targetDom) {
            allSides.push(targetDom);
          }
        });
      }
      allSides.forEach((item, index) => {
        elementIsVisibleInViewport(item, true, 0, 100) && jumpArr.push(index);
      });
      return jumpArr;
    },
  },
};
</script>

<style lang="scss" scoped>
.leftMenu {
  width: 120px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 16px;
  background: #f5f6fa;

  position: fixed;
  top: 100px;
  left: 1%;
  z-index: 9999;
  .menuItem {
    width: 115px;
    border-radius: 14px;
    font-family: Alibaba PuHuiTi;
    font-size: 14px;
    color: #666666;
    text-align: center;
    padding: 8px;
    cursor: pointer;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .menuChecked {
    color: #2a54d1;
    font-weight: bold;
    background: #ffffff;
  }
}
</style>
